/**
 * External store so opening Add Member does not re-render MemberManagement (large table).
 * Subscribers: AddMemberModalLayer only → avoids full-page repaint flash on desktop.
 */

export type AddMemberModalStepState =
  | { step: 'form' }
  | { step: 'success'; email: string; emailWarning: string | null; showResendHint: boolean }
  | { step: 'already_connected'; email: string };

export type AddMemberModalSnapshot = {
  open: boolean;
  modal: AddMemberModalStepState;
  memberEmail: string;
  createError: string | null;
  isCreating: boolean;
};

const initial: AddMemberModalSnapshot = {
  open: false,
  modal: { step: 'form' },
  memberEmail: '',
  createError: null,
  isCreating: false,
};

let snapshot: AddMemberModalSnapshot = { ...initial };

const listeners = new Set<() => void>();

function emit() {
  listeners.forEach((l) => l());
}

function set(next: AddMemberModalSnapshot) {
  snapshot = next;
  emit();
}

export function subscribeAddMemberModal(onChange: () => void) {
  listeners.add(onChange);
  return () => listeners.delete(onChange);
}

export function getAddMemberModalSnapshot(): AddMemberModalSnapshot {
  return snapshot;
}

export function addMemberModalOpen() {
  set({
    ...snapshot,
    open: true,
    modal: { step: 'form' },
    memberEmail: '',
    createError: null,
    isCreating: false,
  });
}

export function addMemberModalClose() {
  set({ ...initial });
}

export function addMemberModalSetForm(email: string) {
  set({ ...snapshot, memberEmail: email, createError: null });
}

export function addMemberModalSetPatch(partial: Partial<AddMemberModalSnapshot>) {
  set({ ...snapshot, ...partial });
}
